module.exports = __webpack_public_path__ + "static/media/banesco-mobile-logo-color.9276350a.svg";